import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { ZInput } from "@/components/ZInput";
import ZButton from "@/components/ZButton";
import Logo from "@/components/Logo";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.must_change_password) nav("/change-password");
      else if (user.role === "organizer" && user.needs_onboarding) nav("/onboarding-organizer");
      else if (user.role === "admin") nav("/admin");
      else if (user.role === "organizer") nav("/org");
      else if (user.role === "agent") nav("/agent/scan");
      else nav("/events");
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="z-container" style={{ maxWidth: 460 }} data-testid="login-page">
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <Logo to={null} size={28} />
      </div>
      <h1 className="z-page-title">Connexion</h1>
      <p className="z-page-sub">Heureux de vous revoir !</p>

      <form onSubmit={submit} className="z-card" style={{ padding: 24 }}>
        <ZInput
          id="email"
          type="email"
          label="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="vous@exemple.com"
          required
          autoComplete="email"
          data-testid="login-email"
        />
        <ZInput
          id="password"
          type="password"
          label="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
          autoComplete="current-password"
          data-testid="login-password"
        />
        {err && <p className="z-error-text" data-testid="login-error">{err}</p>}
        <ZButton type="submit" block loading={loading} data-testid="login-submit-btn">Se connecter</ZButton>
        <div style={{ textAlign: "center", marginTop: 14 }}>
          <Link to="/forgot-password" className="z-link" data-testid="login-forgot-link" style={{ fontSize: 14 }}>
            Mot de passe oublié ?
          </Link>
        </div>
        <div style={{ textAlign: "center", marginTop: 14, fontSize: 14, color: "var(--z-muted)" }}>
          Pas encore de compte ?{" "}
          <Link to="/" className="z-link" data-testid="login-to-register">Créer un compte</Link>
        </div>
      </form>
    </div>
  );
}
